{
    "component-card-search-list.empty-state.title.non-final": "<strong>Vincule este repositório a um componente de software</strong>",
    "component-card.add-chat-channel": "Adicionar canal de bate-papo",
    "component-card.chat-channels": "Canais de bate-papo",
    "component-card.expander.show-more-link": "Mostrar mais {formattedCount}"
}
